export default __webpack_public_path__ + "static/media/nora_philharmonie.1f2bfb88.jpg";